var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{space: !_vm.para.hasForcedBreak}},_vm._l((_vm.para.words),function(token,ti){return _c('TextPanelToken',{key:ti,attrs:{"display-token":token,"allow-single-letter":_vm.allowSingleLetter},on:{"select":i => _vm.$emit('select', i),"dblclick":i => _vm.$emit('dblclick', i)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }